import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { BallBeat } from 'react-pure-loaders';
import { Typography } from '@material-ui/core';

const styles = {
  loading: {
    margin: '0 auto',
    textAlign: 'center',
    width: '100%',
    '& .css-viljga-BallBeat div': {
      width: 15,
      height: 15
    }
  },
  largeLoading: {
    margin: '0 auto',
    transform: 'translateY(45%)',
    textAlign: 'center',
    width: '100%',
    '& .css-viljga-BallBeat div': {
      width: 30,
      height: 30
    }
  }
};

class Loading extends Component {

  render() {

    const { classes, minHeight, size, offset, message } = this.props;

    return (
      <div name="wait-for-loading"
        className={size === "small" ? classes.loading : classes.largeLoading}
        style={
          {
            animation: 'fadeIn 1s',
            ...(minHeight) && { height: minHeight },
            ...(offset) && { paddingTop: offset }
          }} >
        <BallBeat
          color='#97d700'
          loading={true}
        />
        {message &&
          <div style={{ marginTop: 24 }}>
            <Typography className={classes.mainSubHeading} align="center">{message}</Typography>
          </div>
        }
      </ div>
    );

  }
}

Loading.defaultProps = {
  size: 'small',
  offset: '0px'
};

Loading.propTypes = {
  size: PropTypes.string,
  offset: PropTypes.string,
  minHeight: PropTypes.string,
  message: PropTypes.string,
  classes: PropTypes.object
};

export default withStyles(styles)(Loading);